import { Circle, Line, Vector2, Component } from "../Engine";
import { HalfArea, SoccerPlaygroundConfig, Sizes } from "./";

export class PenaltyArea extends Component {

    penaltyPoint: Vector2;
    penaltyAreaLeftLine : Line;
    penaltyAreaRightLine : Line;
    penaltyAreaFrontLine : Line;
    penaltyCircle : Circle;

    constructor(public config: SoccerPlaygroundConfig, public halfArea: HalfArea){
        super();

        const width = Sizes.PenaltyZoneWidth;
        const height = Sizes.PenaltyZoneHeight;

        const yCoordinate = halfArea === HalfArea.UpperArea ? this.config.topLeftCorner.y : this.config.bottomLeftCorner.y;
        const offsetHeight = halfArea === HalfArea.UpperArea ? height * this.config.conversionFactor : -1 * ((height * this.config.conversionFactor));

        this.penaltyAreaLeftLine = new Line(
            new Vector2(this.config.centerPoint.x - (width / 2 * this.config.conversionFactor), yCoordinate),
            new Vector2(this.config.centerPoint.x - (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight)
        );

        this.penaltyAreaRightLine = new Line(
            new Vector2(this.config.centerPoint.x + (width / 2 * this.config.conversionFactor), yCoordinate),
            new Vector2(this.config.centerPoint.x + (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight)
        );

        this.penaltyAreaFrontLine = new Line(
            new Vector2(this.config.centerPoint.x - (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight),
            new Vector2(this.config.centerPoint.x + (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight)
        );


        const penaltyYOffset = halfArea === HalfArea.UpperArea ? Sizes.PenaltyPoint * this.config.conversionFactor : -1 * ((Sizes.PenaltyPoint * this.config.conversionFactor));

        this.penaltyPoint = new Vector2(this.config.centerPoint.x, yCoordinate + penaltyYOffset)

        this.penaltyCircle = new Circle(this.penaltyPoint, 2, true);

        this.children.push(this.penaltyAreaLeftLine, this.penaltyAreaRightLine, this.penaltyAreaFrontLine, this.penaltyCircle);
    }


    draw(ctx: CanvasRenderingContext2D): void {
        super.draw(ctx);
        ctx.restore();

        const radius = Sizes.DistanceRadius * this.config.conversionFactor;

        ctx.beginPath();

        const circleOffset = this.halfArea === HalfArea.UpperArea ? 0 : Math.PI;

        //let angleRad = 18.32 / 57.5; // 0.318
        const angleBegin = 0.645;
        const angleEnd = angleBegin + 1.8525;

        ctx.arc(this.penaltyPoint.x, this.penaltyPoint.y, radius, angleBegin + circleOffset, angleEnd + circleOffset);
        ctx.stroke();
    }

}